import {call, put, takeEvery} from "redux-saga/effects";
import {TYPE_TIRES, TYPE_WHEELS} from "../public/journey1/definition/business";
import Api from "../services/Api";
import Constants from "../services/Constants";

function* fetchIntervention(params) {
  try {
    const intervention = yield call(function () {
      return Api.get(`/intervention/${params.id}`)
    });
    yield put({type: 'FETCH.INTERVENTION.SUCCESS', intervention});
    if (intervention.body && intervention.body.conversationId) {
      yield put({type: 'FETCH.CONVERSATION.REQUEST', id: intervention.body.conversationId});
    }
    yield put({type: 'FETCH.CUSTOMER_CONTACT.REQUEST', params: {vin: intervention.body.vehicle.vin}});
  } catch (error) {
    yield put({type: 'FETCH.INTERVENTION.FAILURE', error});
  }
}

function* fetchInterventionStatus(params) {
  try {
    const status = yield call(function () {
      return Api.get(`/intervention/${params.id}/status`)
    });
    yield put({type: 'FETCH.INTERVENTION_STATUS.SUCCESS', status});
  } catch (error) {
    yield put({type: 'FETCH.INTERVENTION_STATUS.FAILURE', error});
  }
}

function* confirmIntervention(params) {
  const {body = {}} = params;
  try {
    const intervention = yield call(function () {
      return Api.post(`/intervention/${body.id}/confirm`, body.dates)
    });
    yield put({type: 'SAVE.INTERVENTION_CONFIRMATION.SUCCESS', intervention});
    yield put({type: 'FETCH.INTERVENTION.REQUEST', id: body.id});
    yield put({type: 'SHOW_NOTIFICATION', notification: {message: 'save.success'}});
    yield put({type: 'HIDE_CONFIRM_INTERVENTION_MODAL'});
  } catch (error) {
    yield put({type: 'SAVE.INTERVENTION_CONFIRMATION.FAILURE', error});
  }
}

function* archiveIntervention(params) {
  try {
    const intervention = yield call(function () {
      return Api.post(`/intervention/${params.id}/archive`)
    });
    yield put({type: 'ARCHIVE_INTERVENTION.SUCCESS', intervention});
    yield put({type: 'FETCH.INTERVENTION.REQUEST', id: params.id});
    yield put({type: 'SHOW_NOTIFICATION', notification: {message: 'save.success'}});
  } catch (error) {
    yield put({type: 'ARCHIVE_INTERVENTION.FAILURE', error});
  }
}

function* cancelIntervention(params) {
  try {
    const intervention = yield call(function () {
      return Api.post(`/intervention/${params.id}/cancel`)
    });
    yield put({type: 'CANCEL_INTERVENTION.SUCCESS', intervention});
    yield put({type: 'FETCH.INTERVENTION.REQUEST', id: params.id});
    yield put({type: 'SHOW_NOTIFICATION', notification: {message: 'save.success'}});
  } catch (error) {
    yield put({type: 'CANCEL_INTERVENTION.FAILURE', error});
  }
}

function* finishIntervention(params) {
  try {
    const intervention = yield call(function () {
      return Api.post(`/intervention/${params.id}/finish`)
    });
    yield put({type: 'FINISH_INTERVENTION.SUCCESS', intervention});
    yield put({type: 'FETCH.INTERVENTION.REQUEST', id: params.id});
    yield put({type: 'SHOW_NOTIFICATION', notification: {message: 'save.success'}});
  } catch (error) {
    yield put({type: 'FINISH_INTERVENTION.FAILURE', error});
  }
}

function* confirmInterventionSwitch(params) {
  const {body = {}} = params;
  try {
    const intervention = yield call(function () {
      return Api.get(`/intervention/${body.id}`);
    });
    const selectedServices = intervention.body.journey.properties.services;
    selectedServices.tiresExchange.type = selectedServices.tiresExchange.type === TYPE_WHEELS ? TYPE_TIRES : TYPE_WHEELS;
    selectedServices.services = selectedServices.services.map(m => m.name);
    body.intervention.updateJourneyServices = {servicesProperty: {type: Constants.TYPE_TIRES.value, ...selectedServices}};
    body.intervention.day = body.day;
    const confirm = yield call(function () {
      return Api.post(`/intervention/${body.id}/switch`, body.intervention);
    });
    yield put({type: 'SAVE.INTERVENTION_CONFIRMATION.SUCCESS', confirm});
    yield put({type: 'FETCH.INTERVENTION.REQUEST', id: body.id});
    yield put({type: 'SHOW_NOTIFICATION', notification: {message: 'save.success'}});
    yield put({type: 'HIDE_CONFIRM_INTERVENTION_MODAL'});
    yield put({type: `FETCH_${TYPE_TIRES}_EXCHANGE_PLANNING.REQUEST`, request: {type: TYPE_TIRES, day: body.day}});
    yield put({type: `FETCH_${TYPE_TIRES}_EXCHANGE_SLOTS.REQUEST`, request: {type: TYPE_TIRES, day: body.day}});
    yield put({type: `FETCH_${TYPE_WHEELS}_EXCHANGE_PLANNING.REQUEST`, request: {type: TYPE_WHEELS, day: body.day}});
    yield put({type: `FETCH_${TYPE_WHEELS}_EXCHANGE_SLOTS.REQUEST`, request: {type: TYPE_WHEELS, day: body.day}});
  } catch (error) {
    yield put({type: 'SAVE.INTERVENTION_CONFIRMATION.FAILURE', error});
  }
}

export function* watchIntervention() {
  yield takeEvery('FETCH.INTERVENTION.REQUEST', fetchIntervention)
  yield takeEvery('FETCH.INTERVENTION_STATUS.REQUEST', fetchInterventionStatus)
  yield takeEvery('SAVE.INTERVENTION_CONFIRMATION.REQUEST', confirmIntervention)
  yield takeEvery('ARCHIVE_INTERVENTION.REQUEST', archiveIntervention)
  yield takeEvery('CANCEL_INTERVENTION.REQUEST', cancelIntervention)
  yield takeEvery('FINISH_INTERVENTION.REQUEST', finishIntervention)
  yield takeEvery('SWITCH.INTERVENTION_CONFIRMATION.REQUEST', confirmInterventionSwitch)
}
